// keys follow the pattern xxvyy for coordinates (xx,yy) origin at start
module.exports = {
pixel0001	:{red:255,green:255,blue:255,alpha:1},
pixel0002	:{red:255,green:255,blue:255,alpha:1},
pixel0003	:{red:255,green:255,blue:255,alpha:1},
pixel0004	:{red:255,green:255,blue:255,alpha:1},
pixel0005	:{red:255,green:255,blue:255,alpha:1},
pixel0006	:{red:255,green:255,blue:255,alpha:1},
pixel0007	:{red:255,green:255,blue:255,alpha:1},
pixel0008	:{red:255,green:255,blue:255,alpha:1},
pixel0009	:{red:255,green:255,blue:255,alpha:1},
pixel0010	:{red:255,green:255,blue:255,alpha:1},
pixel0011	:{red:255,green:255,blue:255,alpha:1},
pixel0012	:{red:255,green:255,blue:255,alpha:1},
pixel0013	:{red:255,green:255,blue:255,alpha:1},
pixel0014	:{red:255,green:255,blue:255,alpha:1},
pixel0015	:{red:255,green:255,blue:255,alpha:1},
pixel0016	:{red:255,green:255,blue:255,alpha:1},
pixel0017	:{red:255,green:255,blue:255,alpha:1},
pixel0018	:{red:255,green:255,blue:255,alpha:1},
pixel0019	:{red:255,green:255,blue:255,alpha:1},
pixel0020	:{red:255,green:255,blue:255,alpha:1},
pixel0021	:{red:255,green:255,blue:255,alpha:1},
pixel0022	:{red:255,green:255,blue:255,alpha:1},
pixel0023	:{red:255,green:255,blue:255,alpha:1},
pixel0024	:{red:255,green:255,blue:255,alpha:1},
pixel0025	:{red:255,green:255,blue:255,alpha:1},
pixel0026	:{red:255,green:255,blue:255,alpha:1},
pixel0027	:{red:255,green:255,blue:255,alpha:1},
pixel0028	:{red:255,green:255,blue:255,alpha:1},
pixel0029	:{red:255,green:255,blue:255,alpha:1},
pixel0030	:{red:255,green:255,blue:255,alpha:1},
pixel0031	:{red:255,green:255,blue:255,alpha:1},
pixel0032	:{red:255,green:255,blue:255,alpha:1},
pixel0033	:{red:255,green:255,blue:255,alpha:1},
pixel0034	:{red:255,green:255,blue:255,alpha:1},
pixel0035	:{red:255,green:255,blue:255,alpha:1},
pixel0036	:{red:255,green:255,blue:255,alpha:1},
pixel0037	:{red:255,green:255,blue:255,alpha:1},
pixel0038	:{red:255,green:255,blue:255,alpha:1},
pixel0039	:{red:255,green:255,blue:255,alpha:1},
pixel0040	:{red:255,green:255,blue:255,alpha:1},
pixel0041	:{red:255,green:255,blue:255,alpha:1},
pixel0042	:{red:255,green:255,blue:255,alpha:1},
pixel0043	:{red:255,green:255,blue:255,alpha:1},
pixel0044	:{red:255,green:255,blue:255,alpha:1},
pixel0045	:{red:255,green:255,blue:255,alpha:1},
pixel0046	:{red:255,green:255,blue:255,alpha:1},
pixel0047	:{red:255,green:255,blue:255,alpha:1},
pixel0048	:{red:255,green:255,blue:255,alpha:1},
pixel0049	:{red:255,green:255,blue:255,alpha:1},
pixel0050	:{red:255,green:255,blue:255,alpha:1},
pixel0051	:{red:255,green:255,blue:255,alpha:1},
pixel0052	:{red:255,green:255,blue:255,alpha:1},
pixel0053	:{red:255,green:255,blue:255,alpha:1},
pixel0054	:{red:255,green:255,blue:255,alpha:1},
pixel0055	:{red:255,green:255,blue:255,alpha:1},
pixel0056	:{red:255,green:255,blue:255,alpha:1},
pixel0057	:{red:255,green:255,blue:255,alpha:1},
pixel0058	:{red:255,green:255,blue:255,alpha:1},
pixel0059	:{red:255,green:255,blue:255,alpha:1},
pixel0060	:{red:255,green:255,blue:255,alpha:1},
pixel0061	:{red:255,green:255,blue:255,alpha:1},
pixel0062	:{red:255,green:255,blue:255,alpha:1},
pixel0063	:{red:255,green:255,blue:255,alpha:1},
pixel0064	:{red:255,green:255,blue:255,alpha:1},
pixel0065	:{red:255,green:255,blue:255,alpha:1},
pixel0066	:{red:255,green:255,blue:255,alpha:1},
pixel0067	:{red:255,green:255,blue:255,alpha:1},
pixel0068	:{red:255,green:255,blue:255,alpha:1},
pixel0069	:{red:255,green:255,blue:255,alpha:1},
pixel0070	:{red:255,green:255,blue:255,alpha:1},
pixel0071	:{red:255,green:255,blue:255,alpha:1},
pixel0072	:{red:255,green:255,blue:255,alpha:1},
pixel0073	:{red:255,green:255,blue:255,alpha:1},
pixel0074	:{red:255,green:255,blue:255,alpha:1},
pixel0075	:{red:255,green:255,blue:255,alpha:1},
pixel0076	:{red:255,green:255,blue:255,alpha:1},
pixel0077	:{red:255,green:255,blue:255,alpha:1},
pixel0078	:{red:255,green:255,blue:255,alpha:1},
pixel0079	:{red:255,green:255,blue:255,alpha:1},
pixel0080	:{red:255,green:255,blue:255,alpha:1},
pixel0081	:{red:255,green:255,blue:255,alpha:1},
pixel0082	:{red:255,green:255,blue:255,alpha:1},
pixel0083	:{red:255,green:255,blue:255,alpha:1},
pixel0084	:{red:255,green:255,blue:255,alpha:1},
pixel0085	:{red:255,green:255,blue:255,alpha:1},
pixel0086	:{red:255,green:255,blue:255,alpha:1},
pixel0087	:{red:255,green:255,blue:255,alpha:1},
pixel0088	:{red:255,green:255,blue:255,alpha:1},
pixel0089	:{red:255,green:255,blue:255,alpha:1},
pixel0090	:{red:255,green:255,blue:255,alpha:1},
pixel0091	:{red:255,green:255,blue:255,alpha:1},
pixel0092	:{red:255,green:255,blue:255,alpha:1},
pixel0093	:{red:255,green:255,blue:255,alpha:1},
pixel0094	:{red:255,green:255,blue:255,alpha:1},
pixel0095	:{red:255,green:255,blue:255,alpha:1},
pixel0096	:{red:255,green:255,blue:255,alpha:1},
pixel0097	:{red:255,green:255,blue:255,alpha:1},
pixel0098	:{red:255,green:255,blue:255,alpha:1},
pixel0099	:{red:255,green:255,blue:255,alpha:1},
pixel0100	:{red:255,green:255,blue:255,alpha:1},
pixel0101	:{red:255,green:255,blue:255,alpha:1},
pixel0102	:{red:255,green:255,blue:255,alpha:1},
pixel0103	:{red:255,green:255,blue:255,alpha:1},
pixel0104	:{red:255,green:255,blue:255,alpha:1},
pixel0105	:{red:255,green:255,blue:255,alpha:1},
pixel0106	:{red:255,green:255,blue:255,alpha:1},
pixel0107	:{red:255,green:255,blue:255,alpha:1},
pixel0108	:{red:255,green:255,blue:255,alpha:1},
pixel0109	:{red:255,green:255,blue:255,alpha:1},
pixel0110	:{red:255,green:255,blue:255,alpha:1},
pixel0111	:{red:255,green:255,blue:255,alpha:1},
pixel0112	:{red:255,green:255,blue:255,alpha:1},
pixel0113	:{red:255,green:255,blue:255,alpha:1},
pixel0114	:{red:255,green:255,blue:255,alpha:1},
pixel0115	:{red:255,green:255,blue:255,alpha:1},
pixel0116	:{red:255,green:255,blue:255,alpha:1},
pixel0117	:{red:255,green:255,blue:255,alpha:1},
pixel0118	:{red:255,green:255,blue:255,alpha:1},
pixel0119	:{red:255,green:255,blue:255,alpha:1},
pixel0120	:{red:255,green:255,blue:255,alpha:1},
pixel0121	:{red:255,green:255,blue:255,alpha:1},
pixel0122	:{red:255,green:255,blue:255,alpha:1},
pixel0123	:{red:255,green:255,blue:255,alpha:1},
pixel0124	:{red:255,green:255,blue:255,alpha:1},
pixel0125	:{red:255,green:255,blue:255,alpha:1},
pixel0126	:{red:255,green:255,blue:255,alpha:1},
pixel0127	:{red:255,green:255,blue:255,alpha:1},
pixel0128	:{red:255,green:255,blue:255,alpha:1},
pixel0129	:{red:255,green:255,blue:255,alpha:1},
pixel0130	:{red:255,green:255,blue:255,alpha:1},
pixel0131	:{red:255,green:255,blue:255,alpha:1},
pixel0132	:{red:255,green:255,blue:255,alpha:1},
pixel0133	:{red:255,green:255,blue:255,alpha:1},
pixel0134	:{red:255,green:255,blue:255,alpha:1},
pixel0135	:{red:255,green:255,blue:255,alpha:1},
pixel0136	:{red:255,green:255,blue:255,alpha:1},
pixel0137	:{red:255,green:255,blue:255,alpha:1},
pixel0138	:{red:255,green:255,blue:255,alpha:1},
pixel0139	:{red:255,green:255,blue:255,alpha:1},
pixel0140	:{red:255,green:255,blue:255,alpha:1},
pixel0141	:{red:255,green:255,blue:255,alpha:1},
pixel0142	:{red:255,green:255,blue:255,alpha:1},
pixel0143	:{red:255,green:255,blue:255,alpha:1},
pixel0144	:{red:255,green:255,blue:255,alpha:1},
pixel0145	:{red:255,green:255,blue:255,alpha:1},
pixel0146	:{red:255,green:255,blue:255,alpha:1},
pixel0147	:{red:255,green:255,blue:255,alpha:1},
pixel0148	:{red:255,green:255,blue:255,alpha:1},
pixel0149	:{red:255,green:255,blue:255,alpha:1},
pixel0150	:{red:255,green:255,blue:255,alpha:1},
pixel0151	:{red:255,green:255,blue:255,alpha:1},
pixel0152	:{red:255,green:255,blue:255,alpha:1},
pixel0153	:{red:255,green:255,blue:255,alpha:1},
pixel0154	:{red:255,green:255,blue:255,alpha:1},
pixel0155	:{red:255,green:255,blue:255,alpha:1},
pixel0156	:{red:255,green:255,blue:255,alpha:1},
pixel0157	:{red:255,green:255,blue:255,alpha:1},
pixel0158	:{red:255,green:255,blue:255,alpha:1},
pixel0159	:{red:255,green:255,blue:255,alpha:1},
pixel0160	:{red:255,green:255,blue:255,alpha:1},
pixel0161	:{red:255,green:255,blue:255,alpha:1},
pixel0162	:{red:255,green:255,blue:255,alpha:1},
pixel0163	:{red:255,green:255,blue:255,alpha:1},
pixel0164	:{red:255,green:255,blue:255,alpha:1},
pixel0165	:{red:255,green:255,blue:255,alpha:1},
pixel0166	:{red:255,green:255,blue:255,alpha:1},
pixel0167	:{red:255,green:255,blue:255,alpha:1},
pixel0168	:{red:255,green:255,blue:255,alpha:1},
pixel0169	:{red:255,green:255,blue:255,alpha:1},
pixel0170	:{red:255,green:255,blue:255,alpha:1},
pixel0171	:{red:255,green:255,blue:255,alpha:1},
pixel0172	:{red:255,green:255,blue:255,alpha:1},
pixel0173	:{red:255,green:255,blue:255,alpha:1},
pixel0174	:{red:255,green:255,blue:255,alpha:1},
pixel0175	:{red:255,green:255,blue:255,alpha:1},
pixel0176	:{red:255,green:255,blue:255,alpha:1},
pixel0177	:{red:255,green:255,blue:255,alpha:1},
pixel0178	:{red:255,green:255,blue:255,alpha:1},
pixel0179	:{red:255,green:255,blue:255,alpha:1},
pixel0180	:{red:255,green:255,blue:255,alpha:1},
pixel0181	:{red:255,green:255,blue:255,alpha:1},
pixel0182	:{red:255,green:255,blue:255,alpha:1},
pixel0183	:{red:255,green:255,blue:255,alpha:1},
pixel0184	:{red:255,green:255,blue:255,alpha:1},
pixel0185	:{red:255,green:255,blue:255,alpha:1},
pixel0186	:{red:255,green:255,blue:255,alpha:1},
pixel0187	:{red:255,green:255,blue:255,alpha:1},
pixel0188	:{red:255,green:255,blue:255,alpha:1},
pixel0189	:{red:255,green:255,blue:255,alpha:1},
pixel0190	:{red:255,green:255,blue:255,alpha:1},
pixel0191	:{red:255,green:255,blue:255,alpha:1},
pixel0192	:{red:255,green:255,blue:255,alpha:1},
pixel0193	:{red:255,green:255,blue:255,alpha:1},
pixel0194	:{red:255,green:255,blue:255,alpha:1},
pixel0195	:{red:255,green:255,blue:255,alpha:1},
pixel0196	:{red:255,green:255,blue:255,alpha:1},
pixel0197	:{red:255,green:255,blue:255,alpha:1},
pixel0198	:{red:255,green:255,blue:255,alpha:1},
pixel0199	:{red:255,green:255,blue:255,alpha:1},
pixel0200	:{red:255,green:255,blue:255,alpha:1},
pixel0201	:{red:255,green:255,blue:255,alpha:1},
pixel0202	:{red:255,green:255,blue:255,alpha:1},
pixel0203	:{red:255,green:255,blue:255,alpha:1},
pixel0204	:{red:255,green:255,blue:255,alpha:1},
pixel0205	:{red:255,green:255,blue:255,alpha:1},
pixel0206	:{red:255,green:255,blue:255,alpha:1},
pixel0207	:{red:255,green:255,blue:255,alpha:1},
pixel0208	:{red:255,green:255,blue:255,alpha:1},
pixel0209	:{red:255,green:255,blue:255,alpha:1},
pixel0210	:{red:255,green:255,blue:255,alpha:1},
pixel0211	:{red:255,green:255,blue:255,alpha:1},
pixel0212	:{red:255,green:255,blue:255,alpha:1},
pixel0213	:{red:255,green:255,blue:255,alpha:1},
pixel0214	:{red:255,green:255,blue:255,alpha:1},
pixel0215	:{red:255,green:255,blue:255,alpha:1},
pixel0216	:{red:255,green:255,blue:255,alpha:1},
pixel0217	:{red:255,green:255,blue:255,alpha:1},
pixel0218	:{red:255,green:255,blue:255,alpha:1},
pixel0219	:{red:255,green:255,blue:255,alpha:1},
pixel0220	:{red:255,green:255,blue:255,alpha:1},
pixel0221	:{red:255,green:255,blue:255,alpha:1},
pixel0222	:{red:255,green:255,blue:255,alpha:1},
pixel0223	:{red:255,green:255,blue:255,alpha:1},
pixel0224	:{red:255,green:255,blue:255,alpha:1},
pixel0225	:{red:255,green:255,blue:255,alpha:1},
pixel0226	:{red:255,green:255,blue:255,alpha:1},
pixel0227	:{red:255,green:255,blue:255,alpha:1},
pixel0228	:{red:255,green:255,blue:255,alpha:1},
pixel0229	:{red:255,green:255,blue:255,alpha:1},
pixel0230	:{red:255,green:255,blue:255,alpha:1},
pixel0231	:{red:255,green:255,blue:255,alpha:1},
pixel0232	:{red:255,green:255,blue:255,alpha:1},
pixel0233	:{red:255,green:255,blue:255,alpha:1},
pixel0234	:{red:255,green:255,blue:255,alpha:1},
pixel0235	:{red:255,green:255,blue:255,alpha:1},
pixel0236	:{red:255,green:255,blue:255,alpha:1},
pixel0237	:{red:255,green:255,blue:255,alpha:1},
pixel0238	:{red:255,green:255,blue:255,alpha:1},
pixel0239	:{red:255,green:255,blue:255,alpha:1},
pixel0240	:{red:255,green:255,blue:255,alpha:1},
pixel0241	:{red:255,green:255,blue:255,alpha:1},
pixel0242	:{red:255,green:255,blue:255,alpha:1},
pixel0243	:{red:255,green:255,blue:255,alpha:1},
pixel0244	:{red:255,green:255,blue:255,alpha:1},
pixel0245	:{red:255,green:255,blue:255,alpha:1},
pixel0246	:{red:255,green:255,blue:255,alpha:1},
pixel0247	:{red:255,green:255,blue:255,alpha:1},
pixel0248	:{red:255,green:255,blue:255,alpha:1},
pixel0249	:{red:255,green:255,blue:255,alpha:1},
pixel0250	:{red:255,green:255,blue:255,alpha:1},
pixel0251	:{red:255,green:255,blue:255,alpha:1},
pixel0252	:{red:255,green:255,blue:255,alpha:1},
pixel0253	:{red:255,green:255,blue:255,alpha:1},
pixel0254	:{red:255,green:255,blue:255,alpha:1},
pixel0255	:{red:255,green:255,blue:255,alpha:1},
pixel0256	:{red:255,green:255,blue:255,alpha:1}
}



/** WEBPACK FOOTER **
 ** ./src/components/blankCanvasTest.js
 **/